import RecommendationModal from './RecommendationModal';

export default RecommendationModal;
